import React, { useContext, useEffect, useRef, useState } from 'react';
import { LinerServiceAdminContext, LinerServiceAdminSettings } from './linerServiceAdmin';

export interface LinerServiceDeleteDialogProps {
  id: string;
  visible: boolean;
  onConfirmClick: Function;
  onDenyClick: Function;
}

export interface LinerServiceDeleteDialogData {
  deletePosX: number;
  deletePosY: number;
  onDeleteConfirmation: Function;
}

const LinerServiceDeleteDialog = ({ id, visible, onConfirmClick, onDenyClick }: LinerServiceDeleteDialogProps) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(visible);
  }, [visible]);

  const onYesClick = () => {
    setShow(true);
    onConfirmClick();
  };
  // const onNoClick = () => {
  //   setShow(false);
  // };

  return (
    <div ref={ref} className={`confirm-delete-dialog ${show ? 'show' : ''}`}>
      <div className="confirm-delete-dialog-content">
        <h5>Är du säker på att du vill ta bort rutten?</h5>
        <button onClick={onYesClick} type="button" className="confirm-remove-button yes">
          Ja
        </button>
        <button onClick={() => onDenyClick()} type="button" className="confirm-remove-button no">
          Nej
        </button>
      </div>
    </div>
  );
};

export default LinerServiceDeleteDialog;
